import type { FC, ReactNode } from 'react'
import type { AccessRole } from '@/types'

import { useCallback, useState } from 'react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { Marquee } from '@/components/landing/marquee'
import { SimulationsSection } from '@/components/landing/simulations-section'
import { LabSection } from '@/components/landing/lab-section'
import { HowItWorksSection } from '@/components/landing/how-it-works-section'
import { PlatformSection } from '@/components/landing/platform-section'
import { TestimonialsSection } from '@/components/landing/testimonials-section'
import { PricingSection } from '@/components/landing/pricing-section'
import { FaqSection } from '@/components/landing/faq-section'
import { AccessSection } from '@/components/landing/access-section'

const Home: FC = (): ReactNode => {
    const [role, setRole] = useState<AccessRole>('student')

    const handleChoosePlan = useCallback((nextRole: AccessRole | null) => {
        if (nextRole) setRole(nextRole)
    }, [])

    return (
        <Layout>
            <Seo />

            <HeroSection />
            <Marquee />
            <SimulationsSection />
            <LabSection />
            <HowItWorksSection />
            <PlatformSection />
            <TestimonialsSection />
            <PricingSection onChoose={handleChoosePlan} />
            <FaqSection />
            <AccessSection role={role} onRoleChange={setRole} />
        </Layout>
    )
}

export default Home
